import { Product } from '../models/product.model';
import { MOCK_CATEGORIES } from './mock-categories';

export const MOCK_PRODUCTS: Product[] = [
  {
    id: 1,
    nome: 'Farol Dianteiro Esquerdo Fiat Uno 2010-2014',
    codigo: 'FAR-UNO-10-E',
    preco: 285.90,
    imagemURL: 'assets/images/mock/farol-esquerdo-uno-2010-2014-1.jpg',
    imagens: [
      'assets/images/mock/farol-esquerdo-uno-2010-2014-1.jpg',
      'assets/images/mock/farol-esquerdo-uno-2010-2014-2.jpg',
      'assets/images/mock/farol-esquerdo-uno-2010-2014-3.jpg',
    ],
    categoria: MOCK_CATEGORIES[0],
    descricaoCurta: 'Farol original para Fiat Uno 2010 a 2014',
    descricao: 'Farol dianteiro esquerdo compatível com Fiat Uno modelos 2010 a 2014. Produto novo, com garantia de 90 dias. Iluminação de alta qualidade.',
    estoque: { saldo: 8 },
    veiculoCompativel: [
      { marca: 'Fiat', modelo: 'Uno', anoInicio: 2010, anoFim: 2014 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
    novo: true,
  },
  {
    id: 2,
    nome: 'Farol Dianteiro Direito Fiat Uno 2010-2014',
    codigo: 'FAR-UNO-10-D',
    preco: 285.90,
    imagemURL: 'assets/images/mock/farol-direito-uno-2010-2014-1.jpg',
    imagens: [
      'assets/images/mock/farol-direito-uno-2010-2014-1.jpg',
      'assets/images/mock/farol-direito-uno-2010-2014-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[0],
    descricaoCurta: 'Farol original para Fiat Uno 2010 a 2014',
    descricao: 'Farol dianteiro direito compatível com Fiat Uno modelos 2010 a 2014. Produto novo, com garantia de 90 dias.',
    estoque: { saldo: 12 },
    veiculoCompativel: [
      { marca: 'Fiat', modelo: 'Uno', anoInicio: 2010, anoFim: 2014 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 3,
    nome: 'Farol VW Gol G5 2008-2012 Esquerdo',
    codigo: 'FAR-GOL-G5-E',
    preco: 325.50,
    imagemURL: 'assets/images/mock/farol-esquerdo-gol-g5-2008-2012-1.jpg',
    imagens: [
      'assets/images/mock/farol-esquerdo-gol-g5-2008-2012-1.jpg',
      'assets/images/mock/farol-esquerdo-gol-g5-2008-2012-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[0],
    descricaoCurta: 'Farol original para VW Gol G5',
    descricao: 'Farol dianteiro esquerdo para Volkswagen Gol G5 2008-2012. Produto com certificação Inmetro.',
    estoque: { saldo: 0 },
    veiculoCompativel: [
      { marca: 'Volkswagen', modelo: 'Gol', anoInicio: 2008, anoFim: 2012 },
      { marca: 'Volkswagen', modelo: 'Voyage', anoInicio: 2008, anoFim: 2012 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 4,
    nome: 'Lanterna Traseira Chevrolet Onix 2012-2019',
    codigo: 'LAN-ONIX-12',
    preco: 195.00,
    imagemURL: 'assets/images/mock/lanterna-esqueda-onix-2012-2016-1.jpg',
    categoria: MOCK_CATEGORIES[1],
    descricaoCurta: 'Lanterna traseira para Onix primeira geração',
    descricao: 'Lanterna traseira compatível com Chevrolet Onix 2012-2019. Lado esquerdo motorista.',
    estoque: { saldo: 15 },
    veiculoCompativel: [
      { marca: 'Chevrolet', modelo: 'Onix', anoInicio: 2012, anoFim: 2019 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 5,
    nome: 'Retrovisor Elétrico Ford Ka 2014-2018 Direito',
    codigo: 'RET-KA-14-D',
    preco: 380.00,
    imagemURL: 'assets/images/mock/retrovisor-elétrico-ford-ka-2014-2018-direito-1.jpg',
    imagens: [
      'assets/images/mock/retrovisor-elétrico-ford-ka-2014-2018-direito-1.jpg',
      'assets/images/mock/retrovisor-elétrico-ford-ka-2014-2018-direito-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[2],
    descricaoCurta: 'Retrovisor com regulagem elétrica',
    descricao: 'Retrovisor externo direito com regulagem elétrica para Ford Ka 2014-2018. Produto original de linha.',
    estoque: { saldo: 0 },
    veiculoCompativel: [
      { marca: 'Ford', modelo: 'Ka', anoInicio: 2014, anoFim: 2018 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 6,
    nome: 'Para-choque Dianteiro Hyundai HB20 2012-2015',
    codigo: 'PAR-HB20-12',
    preco: 485.00,
    imagemURL: 'assets/images/mock/Para-choque-Dianteiro-Hyundai-HB20-2012-2015-1.jpg',
    imagens: [
      'assets/images/mock/Para-choque-Dianteiro-Hyundai-HB20-2012-2015-1.jpg',
      'assets/images/mock/Para-choque-Dianteiro-Hyundai-HB20-2012-2015-2.jpg',
      'assets/images/mock/Para-choque-Dianteiro-Hyundai-HB20-2012-2015-3.jpg',
    ],
    categoria: MOCK_CATEGORIES[3],
    descricaoCurta: 'Para-choque dianteiro compatível',
    descricao: 'Para-choque dianteiro para Hyundai HB20 2012-2015. Pronto para pintura, não acompanha grade.',
    estoque: { saldo: 2 },
    veiculoCompativel: [
      { marca: 'Hyundai', modelo: 'HB20', anoInicio: 2012, anoFim: 2015 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
    novo: true,
  },
  {
    id: 9,
    nome: 'Farol Neblina Toyota Corolla 2015-2017',
    codigo: 'FAR-COR-NEB-15',
    preco: 225.00,
    imagemURL: 'assets/images/mock/Farol-Neblina-Toyot-Corolla-2015-2017-1.jpg',
    imagens: [
      'assets/images/mock/Farol-Neblina-Toyot-Corolla-2015-2017-1.jpg',
      'assets/images/mock/Farol-Neblina-Toyot-Corolla-2015-2017-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[0],
    descricaoCurta: 'Farol de neblina original',
    descricao: 'Farol auxiliar de neblina para Toyota Corolla 2015-2017. Par (esquerdo e direito).',
    estoque: { saldo: 10 },
    veiculoCompativel: [
      { marca: 'Toyota', modelo: 'Corolla', anoInicio: 2015, anoFim: 2017 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'PAR',
  },
  {
    id: 11,
    nome: 'Lanterna Traseira Fiat Strada 2013-2020 Esquerdo',
    codigo: 'LAN-STR-13',
    preco: 245.00,
    imagemURL: 'assets/images/mock/Lanterna-Traseira-Fiat-Strada-2013-2020-esquerdo-1.jpg',
    imagens: [
      'assets/images/mock/Lanterna-Traseira-Fiat-Strada-2013-2020-esquerdo-1.jpg',
      'assets/images/mock/Lanterna-Traseira-Fiat-Strada-2013-2020-esquerdo-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[1],
    descricaoCurta: 'Lanterna traseira lado esquerdo',
    descricao: 'Lanterna traseira esquerda para Fiat Strada 2013-2020. Produto novo com garantia.',
    estoque: { saldo: 6 },
    veiculoCompativel: [
      { marca: 'Fiat', modelo: 'Strada', anoInicio: 2013, anoFim: 2020 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 12,
    nome: 'Farol Completo Nissan March 2011-2014',
    codigo: 'FAR-MAR-11',
    preco: 295.00,
    imagemURL: 'assets/images/mock/Farol-Completo-Nissan-March-2011-2014-direiro-1.jpg',
    imagens: [
      'assets/images/mock/Farol-Completo-Nissan-March-2011-2014-direiro-1.jpg',
      'assets/images/mock/Farol-Completo-Nissan-March-2011-2014-direiro-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[0],
    descricaoCurta: 'Farol completo com lâmpadas Direito',
    descricao: 'Farol dianteiro direito completo para Nissan March 2011-2014. Acompanha soquetes.',
    estoque: { saldo: 9 },
    veiculoCompativel: [
      { marca: 'Nissan', modelo: 'March', anoInicio: 2011, anoFim: 2014 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 15,
    nome: 'Paralama Esquerdo Ford EcoSport 2012-2019',
    codigo: 'PAL-ECO-12-E',
    preco: 395.00,
    imagemURL: 'assets/images/mock/Paralama-Esquerdo-Ford-EcoSport-2012-2019-1.jpg',
    imagens: [
      'assets/images/mock/Paralama-Esquerdo-Ford-EcoSport-2012-2019-1.jpg',
      'assets/images/mock/Paralama-Esquerdo-Ford-EcoSport-2012-2019-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[3],
    descricaoCurta: 'Paralama lateral esquerdo',
    descricao: 'Paralama dianteiro esquerdo para Ford EcoSport 2012-2019. Com furo para pisca.',
    estoque: { saldo: 5 },
    veiculoCompativel: [
      { marca: 'Ford', modelo: 'EcoSport', anoInicio: 2012, anoFim: 2019 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 16,
    nome: 'Farol LED Fiat Argo 2017-2023',
    codigo: 'FAR-ARG-17-LED',
    preco: 625.00,
    imagemURL: 'assets/images/mock/Farol-LED-Fiat-Argo-2017-2023-1.jpg',
    imagens: [
      'assets/images/mock/Farol-LED-Fiat-Argo-2017-2023-1.jpg',
      'assets/images/mock/Farol-LED-Fiat-Argo-2017-2023-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[0],
    descricaoCurta: 'Farol com tecnologia LED',
    descricao: 'Farol dianteiro direito com tecnologia LED para Fiat Argo 2017-2023. Modelo Premium.',
    estoque: { saldo: 3 },
    veiculoCompativel: [
      { marca: 'Fiat', modelo: 'Argo', anoInicio: 2017, anoFim: 2023 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
    novo: true,
  },
  {
    id: 17,
    nome: 'Lanterna Traseira VW Polo 2018-2023',
    codigo: 'LAN-POL-18',
    preco: 385.00,
    imagemURL: 'assets/images/mock/Lanterna-Traseira-VW-Polo-2018-2023.jpg',
    categoria: MOCK_CATEGORIES[1],
    descricaoCurta: 'Lanterna LED lado esquerdo',
    descricao: 'Lanterna traseira esquerda com LED para VW Polo 2018-2023. Design moderno.',
    estoque: { saldo: 7 },
    veiculoCompativel: [
      { marca: 'Volkswagen', modelo: 'Polo', anoInicio: 2018, anoFim: 2023 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 18,
    nome: 'Retrovisor Elétrico Chevrolet Tracker 2020-2023',
    codigo: 'RET-TRA-20-E',
    preco: 545.00,
    imagemURL: 'assets/images/mock/Retrovisor-Elétrico-Chevrolet-Tracker-2020-2023-1.jpg',
    imagens: [
      'assets/images/mock/Retrovisor-Elétrico-Chevrolet-Tracker-2020-2023-1.jpg',
      'assets/images/mock/Retrovisor-Elétrico-Chevrolet-Tracker-2020-2023-2.jpg',
    ],
    categoria: MOCK_CATEGORIES[2],
    descricaoCurta: 'Retrovisor elétrico com pisca',
    descricao: 'Retrovisor externo esquerdo elétrico com pisca integrado para Chevrolet Tracker 2020-2023.',
    estoque: { saldo: 4 },
    veiculoCompativel: [
      { marca: 'Chevrolet', modelo: 'Tracker', anoInicio: 2020, anoFim: 2023 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
  {
    id: 19,
    nome: 'Para-choque Traseiro Hyundai Creta 2016-2021',
    codigo: 'PAR-CRE-16-T',
    preco: 525.00,
    imagemURL: 'assets/images/mock/Para-choque-Traseiro-Hyundai-Creta-2016-2021-1.jpg',
    categoria: MOCK_CATEGORIES[3],
    descricaoCurta: 'Para-choque traseiro original',
    descricao: 'Para-choque traseiro para Hyundai Creta 2016-2021. Pronto para pintura.',
    estoque: { saldo: 2 },
    veiculoCompativel: [
      { marca: 'Hyundai', modelo: 'Creta', anoInicio: 2016, anoFim: 2021 },
    ],
    tipo: 'P',
    situacao: 'A',
    formato: 'S',
    unidade: 'UN',
  },
];

